<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-toolbar cad color="primary" dark dense flat>
            <v-toolbar-title class="subheading">
              {{ $route.meta.title }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-card-text>
            <v-form>
              <v-layout row wrap>
                <v-flex md6 xs12>
                  <v-combobox
                    :error-messages="errors.collect('name')"
                    :items="products"
                    :search-input.sync="search"
                    @input="onChange"
                    chips
                    clearable
                    data-vv-name="name"
                    item-text="name"
                    item-value="id"
                    label="Nombre"
                    v-model="selectedProduct"
                    v-validate="'required'"
                  >
                    <template
                      v-slot:selection="{ attrs, item, parent, selected }"
                    >
                      <v-chip
                        :input-value="selected"
                        :key="JSON.stringify(item)"
                        v-bind="attrs"
                        v-if="item === String(item)"
                      >
                        <v-avatar
                          class="accent"
                          v-text="item.slice(0, 1).toUpperCase()"
                        ></v-avatar>
                        {{ item }}
                      </v-chip>

                      <v-chip
                        :input-value="selected"
                        :key="JSON.stringify(item.name)"
                        v-bind="attrs"
                        v-if="item === Object(item)"
                      >
                        <v-avatar
                          class="accent"
                          v-text="item.name.slice(0, 1).toUpperCase()"
                        ></v-avatar>
                        {{ item.name }}
                      </v-chip>
                    </template>
                    <template v-slot:no-data>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            No hay resultados que coincidan con "
                            <strong>{{ search }}</strong
                            >".
                          </v-list-tile-title>
                          <v-list-tile-title>
                            Presione
                            <kbd>enter</kbd> para crear un nuevo producto
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </template>
                  </v-combobox>
                </v-flex>
                <v-flex md6 xs12>
                  <v-text-field
                    :error-messages="errors.collect('formula')"
                    data-vv-name="formula"
                    label="Presentacion"
                    required
                    v-model="form.formula"
                    v-validate="'required'"
                  ></v-text-field>
                </v-flex>
                <v-flex md6 xs12>
                  <v-text-field
                    :error-messages="errors.collect('sanitaryReg')"
                    data-vv-name="sanitaryReg"
                    label="Registro Sanitario"
                    required
                    v-model="form.sanitaryReg"
                    v-validate="'required'"
                  ></v-text-field>
                </v-flex>
                <v-flex md6 xs12>
                  <v-text-field
                    :error-messages="errors.collect('lote')"
                    data-vv-name="lote"
                    label="# de Lote"
                    required
                    v-model="form.lote"
                    v-validate="'required'"
                  ></v-text-field>
                </v-flex>
                <v-flex md12 xs12>
                  <v-dialog
                    :return-value.sync="form.expDate"
                    full-width
                    ref="dialog"
                    v-model="modalExpdate"
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :error-messages="errors.collect('expDate')"
                        append-icon="event"
                        data-vv-name="expDate"
                        label="Expiracion de Reg. Sanitario"
                        readonly
                        v-model="form.expDate"
                        v-on="on"
                        v-validate="'required'"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="es-es"
                      scrollable
                      v-model="form.expDate"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        @click="modalExpdate = false"
                        color="primary"
                        flat
                        text
                        >Cancel</v-btn
                      >
                      <v-btn
                        @click="$refs.dialog.save(form.expDate)"
                        color="primary"
                        flat
                        text
                        >OK</v-btn
                      >
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex md6 xs12>
                  <v-switch
                    :label="`¿Certificado? - ${form.certificate ? 'Si' : 'No'}`"
                    v-model="form.certificate"
                  ></v-switch>
                </v-flex>
                <v-flex md6 v-if="form.certificate" xs12>
                  <v-text-field
                    :error-messages="errors.collect('total_certificate')"
                    data-vv-name="total_certificate"
                    label="Cantidad de Certificados"
                    required
                    v-model="form.total_certificate"
                    v-validate="'required|numeric'"
                  ></v-text-field>
                </v-flex>
                <v-flex md12 xs12>
                  <v-select
                    no-data-text="Datos no disponibles"
                    :error-messages="errors.collect('laboratory')"
                    :items="laboratories"
                    data-vv-name="laboratory"
                    label="Laboratorio"
                    required
                    v-model="form.laboratory"
                    v-validate="'required'"
                  ></v-select>
                </v-flex>
                <v-flex md12 xs12>
                  <v-btn @click="submit" color="success">Enviar</v-btn>
                  <v-btn
                    @click="$router.push('/productos/listado')"
                    color="error"
                    >Cancelar</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-dialog max-width="500" v-if="dialog.message" v-model="dialog.show">
        <message
          :key="dialog.key"
          :options="dialog"
          v-on:close="dialog.show = false"
        ></message>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import message from './../dialog/Message'
export default {
  components: {
    message,
  },
  props: {
    form: {
      type: Object,
      default() {
        return {
          product: {
            id: null,
            name: '',
          },
          formula: '',
          sanitaryReg: '',
          lote: '',
          expDate: null,
          certificate: 1,
          total_certificate: '',
          laboratory: '',
        }
      },
    },
  },
  data() {
    return {
      search: null,
      modalExpdate: false,
      selectedProduct: null,
      laboratories: [],
      products: [],
      dialog: {
        show: false,
        key: 0,
      },
    }
  },

  created() {
    this.$store.dispatch('laboratories/getAll', {}).then(response => {
      const data = response.items
      for (let index = 0; index < data.length; index += 1) {
        this.laboratories.push({
          text: data[index].name,
          value: data[index].id,
        })
      }
    })

    if ('id' in this.$route.params) {
      this.$store
        .dispatch('products/getById', {
          id: this.$route.params.id,
        })
        .then(response => {
          if (response) {
            this.form = Object.assign(this.form, {
              id: response.id,
              product: {
                id: response.product.id,
                name: response.product.name,
              },
              formula: response.fxFormula,
              sanitaryReg: response.sanitaryReg,
              lote: response.batchNumber,
              expDate: response.expirationDate,
              certificate: response.certificate,
              total_certificate: response.total_certificate,
              laboratory: response.laboratory.id,
            })
            this.selectedProduct = response.product
          } else {
            this.$router.push('/productos/listado')
          }
        })
    }
    this.$store.dispatch('products/getAll', {}).then(response => {
      const data = response.items
      for (let index = 0; index < data.length; index += 1) {
        this.products.push({
          name: data[index].product.name,
          id: data[index].product.id,
        })
      }
    })
  },
  methods: {
    onChange(val) {
      if (val != null) {
        this.form.product = val.id
          ? { id: val.id, name: val.name }
          : { id: null, name: val }
      }
    },

    submit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store.dispatch('products/save', this.form).then(response => {
            if (response.status === 200) {
              if (this.form.id) {
                this.dialog = {
                  message: 'Los datos fueron actualizados exitosamente',
                  color: 'primary',
                  show: true,
                  key: this.dialog.key + 1,
                }
              } else {
                this.$router.push('/productos/listado?success=true')
              }
            } else {
              this.dialog = {
                message: response.data.error,
                color: 'error',
                show: true,
                key: this.dialog.key + 1,
              }
            }
          })
        }
      })
    },
  },
}
</script>
